// Mock data for L'Élan Danse website

export const SITE = {
  name: "L'Élan Danse",
  tagline: "Cours de danse classique et moderne au Perray-en-Yvelines",
  city: "Le Perray-en-Yvelines",
  postal: "78610",
  address: "12 rue de la Mairie, 78610 Le Perray-en-Yvelines",
  phone: "01 30 00 00 00",
  email: "contact@elan-danse.fr",
  inscriptionDate: "SAMEDI 6 SEPTEMBRE 2025 à 10h",
  season: "2026/2027",
  nextSeason: "2026/2027",
  planningNote: "Planning valable jusqu'à décembre 2026. Après les vacances de Noël, le cours du samedi aura lieu de 12h30 à 14h00 dans la salle de danse.",
};

export const HERO_IMAGE = "https://images.unsplash.com/photo-1518834107812-67b0b7c58434?w=1920&q=85";

export const COURSES = [
  {
    id: "eveil",
    name: "Éveil / Poussins",
    age: "3 - 5 ans",
    desc: "Premier contact ludique avec la danse, développement de la motricité, du sens du rythme et de la créativité dans une ambiance joyeuse et bienveillante.",
    duration: "1h",
    image: "https://images.pexels.com/photos/5635577/pexels-photo-5635577.jpeg?w=800&q=80",
    color: "bg-rose-100",
  },
  {
    id: "initiation",
    name: "Initiation",
    age: "6 - 7 ans",
    desc: "Apprentissage des bases de la danse classique : posture, placement, vocabulaire. Première approche structurée tout en gardant le plaisir au cœur du cours.",
    duration: "1h - 1h15",
    image: "https://images.unsplash.com/photo-1524594152303-9fd13543fe6e?w=800&q=80",
    color: "bg-amber-50",
  },
  {
    id: "preparatoire",
    name: "Préparatoire",
    age: "7 - 9 ans",
    desc: "Niveaux Débutant, Préparatoire 1, 2 et 3 — consolidation de la technique classique, travail de la musicalité et premiers enchaînements chorégraphiques.",
    duration: "1h - 1h30",
    image: "https://images.pexels.com/photos/8935909/pexels-photo-8935909.jpeg?w=800&q=80",
    color: "bg-pink-100",
  },
  {
    id: "elementaire-moyen",
    name: "Élémentaire / Moyen",
    age: "9 - 13 ans",
    desc: "Travail approfondi de la barre, du milieu et des sauts. Initiation aux pointes selon validation. Progression vers les niveaux Moyen Sup et Supérieur.",
    duration: "1h15 - 1h30",
    image: "https://images.unsplash.com/photo-1495791185843-c73f2269f669?w=800&q=80",
    color: "bg-sky-100",
  },
  {
    id: "superieur-avance",
    name: "Supérieur / Avancé",
    age: "13 ans et +",
    desc: "Pour danseuses confirmées : technique exigeante, variations, pointes, préparation aux concours et au spectacle annuel.",
    duration: "1h15 - 1h30",
    image: "https://images.unsplash.com/photo-1547153760-18fc86324498?w=800&q=80",
    color: "bg-purple-100",
  },
  {
    id: "adultes",
    name: "Cours Adultes",
    age: "Tous niveaux",
    desc: "Classique adultes et barre au sol — un moment pour soi, pour entretenir son corps, sa souplesse et se reconnecter au plaisir de danser.",
    duration: "1h15 - 1h30",
    image: "https://images.pexels.com/photos/8463037/pexels-photo-8463037.jpeg?w=800&q=80",
    color: "bg-yellow-50",
  },
];

export const TEACHERS = [
  {
    id: "jessica",
    name: "Jessica",
    discipline: "Danse classique",
    color: "bg-orange-500",
    colorClass: "text-orange-700",
    photo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80",
    bio: "Professeure principale de l'école, Jessica enseigne la danse classique des plus petits aux adultes. Titulaire du Diplôme d'État, elle accompagne chaque danseur avec exigence et bienveillance, du Débutant au niveau Supérieur, en passant par la préparation aux concours.",
    quote: "« Donner le goût de la danse à chacun, quel que soit son âge ou son niveau, c'est la plus belle des récompenses. »",
  },
  {
    id: "france",
    name: "France",
    discipline: "Moyen, Adultes & Avancés",
    color: "bg-purple-700",
    colorClass: "text-purple-800",
    photo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80",
    bio: "France enseigne les niveaux Moyen, Avancés et le cours Adultes du mercredi. Sa rigueur technique alliée à une approche artistique sensible permet aux danseurs de gagner en maturité et en expressivité scénique.",
    quote: "« La technique au service de l'émotion, voilà ce qui fait grandir un danseur. »",
  },
  {
    id: "alicia",
    name: "Alicia",
    discipline: "Élémentaire",
    color: "bg-amber-200",
    colorClass: "text-amber-700",
    photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80",
    bio: "Alicia est en charge des cours Élémentaire du samedi. Pédagogue passionnée, elle apporte un soin particulier au placement, à la musicalité et au plaisir du mouvement chez les jeunes danseuses.",
    quote: "« Chaque cours est une nouvelle aventure, chaque élève une histoire à écrire. »",
  },
  {
    id: "jennifer",
    name: "Jennifer",
    discipline: "Poussins, Initiation 1 & Répétitions",
    color: "bg-pink-500",
    colorClass: "text-pink-700",
    photo: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=400&q=80",
    bio: "Jennifer accompagne les tout-petits (Poussins) et les niveaux Initiation 1. Elle est également en charge des répétitions du vendredi pour le spectacle. Douceur, jeu et créativité guident chacun de ses cours.",
    quote: "« Chez les plus jeunes, chaque sourire est une victoire, chaque pas une découverte. »",
  },
];

// Color helper for planning slots
const C = {
  jessica: "bg-orange-500 text-white",
  alicia: "bg-amber-200 text-amber-900",
  france: "bg-purple-700 text-white",
  jennifer: "bg-pink-500 text-white",
};

export const PLANNING = [
  {
    day: "Lundi",
    slots: [
      { time: "17h00 - 18h00", course: "Poussins 1", teacher: "Jennifer", room: "Salle de danse", color: C.jennifer },
      { time: "18h00 - 19h00", course: "Initiation 2", teacher: "Jennifer", room: "Salle de danse", color: C.jennifer },
      { time: "19h00 - 20h30", course: "Inter", teacher: "Jennifer", room: "Salle de danse", color: C.jennifer },
    ],
  },
  {
    day: "Mardi",
    slots: [
      { time: "17h00 - 18h15", course: "Élémentaire 1", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
      { time: "18h15 - 19h45", course: "Moyen Sup", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
      { time: "19h45 - 21h15", course: "Adultes", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
    ],
  },
  {
    day: "Mercredi",
    slots: [
      { time: "10h00 - 11h00", course: "Débutant", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
      { time: "11h00 - 12h00", course: "Préparatoire 1 & 2", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
      { time: "12h00 - 13h30", course: "Préparatoire 3", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
      { time: "14h00 - 15h30", course: "Élémentaire 1", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
      { time: "15h30 - 17h00", course: "Élémentaire 2 / Moyen", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
      { time: "17h00 - 18h30", course: "Moyen", teacher: "France", room: "Salle de danse", color: C.france },
      { time: "18h30 - 20h00", course: "Adultes", teacher: "France", room: "Salle de danse", color: C.france },
      { time: "20h00 - 21h30", course: "Avancés", teacher: "France", room: "Salle de danse", color: C.france },
    ],
  },
  {
    day: "Jeudi",
    slots: [
      { time: "17h00 - 18h30", course: "Concours", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
      { time: "18h30 - 19h30", course: "Barre au sol", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
      { time: "19h30 - 21h00", course: "Supérieur", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
    ],
  },
  {
    day: "Vendredi",
    slots: [
      { time: "17h00 - 18h00", course: "Concours", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
      { time: "19h00 - 21h00", course: "Répétitions", teacher: "Jennifer", room: "Salle de danse", color: C.jennifer },
    ],
  },
  {
    day: "Samedi",
    slots: [
      { time: "10h00 - 11h00", course: "Préparatoire 3", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
      { time: "11h00 - 12h30", course: "Élémentaire 2", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
      { time: "11h15 - 12h15", course: "Poussins 2", teacher: "Jennifer", room: "Salle de ping-pong", color: C.jennifer },
      { time: "12h30 - 13h30", course: "Barre au sol", teacher: "Jessica", room: "Salle des sports", color: C.jessica },
      { time: "12h30 - 13h45", course: "Élémentaire", teacher: "Alicia", room: "Salle de danse", color: C.alicia },
      { time: "14h00 - 15h15", course: "Supérieur", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
      { time: "14h00 - 15h15", course: "Initiation 1", teacher: "Jennifer", room: "Salle de multi-activités", color: C.jennifer },
      { time: "15h15 - 16h45", course: "Moyen", teacher: "Jessica", room: "Salle de danse", color: C.jessica },
      { time: "16h45 - 18h15", course: "Élémentaire", teacher: "Alicia", room: "Salle de danse", color: C.alicia },
    ],
  },
];

export const TARIFS = [
  { course: "Éveil / Poussins (1h)", year: "320 €", trimester: "120 €" },
  { course: "Initiation (1h - 1h15)", year: "360 €", trimester: "135 €" },
  { course: "Préparatoire (1h - 1h30)", year: "395 €", trimester: "145 €" },
  { course: "Élémentaire / Moyen (1h15 - 1h30)", year: "435 €", trimester: "160 €" },
  { course: "Supérieur / Avancé (1h15 - 1h30)", year: "475 €", trimester: "175 €" },
  { course: "Adultes (1h15 - 1h30)", year: "450 €", trimester: "165 €" },
  { course: "Barre au sol (1h)", year: "320 €", trimester: "120 €" },
  { course: "2ème cours (par élève)", year: "- 15%", trimester: "- 15%" },
  { course: "3ème cours et + (par élève)", year: "- 25%", trimester: "- 25%" },
];

export const TENUES = [
  { course: "Éveil & Poussins", items: "Justaucorps rose pâle, collants rose, chaussons de danse roses, cheveux attachés." },
  { course: "Initiation & Préparatoire", items: "Justaucorps de couleur définie par niveau, collants rose, chaussons demi-pointes." },
  { course: "Élémentaire & Moyen", items: "Justaucorps, collants rose, chaussons demi-pointes, jupette autorisée. Pointes selon validation." },
  { course: "Supérieur & Avancé", items: "Justaucorps, collants rose, chaussons demi-pointes et pointes. Tenue exigée pour les concours." },
  { course: "Barre au sol", items: "Tenue souple et près du corps, chaussettes ou pieds nus." },
  { course: "Adultes", items: "Tenue de danse confortable, chaussons adaptés à la discipline." },
];

export const DATES = [
  { label: "Rentrée", value: "Lundi 8 septembre 2026" },
  { label: "Portes Ouvertes", value: "Samedi 14 juin 2026" },
  { label: "Semaine à thème — Halloween", value: "Du 19 au 24 octobre 2026" },
  { label: "Vacances de Noël", value: "Du 21 décembre 2026 au 3 janvier 2027" },
  { label: "Semaine à thème — Carnaval", value: "Du 15 au 20 février 2027" },
  { label: "Spectacle de fin d'année", value: "Samedi 19 juin 2027 — Salle des fêtes du Perray" },
];

export const GALLERY = [
  "https://images.unsplash.com/photo-1518834107812-67b0b7c58434?w=800&q=80",
  "https://images.pexels.com/photos/358010/pexels-photo-358010.jpeg?w=800&q=80",
  "https://images.pexels.com/photos/5635577/pexels-photo-5635577.jpeg?w=800&q=80",
  "https://images.unsplash.com/photo-1547153760-18fc86324498?w=800&q=80",
  "https://images.unsplash.com/photo-1524594152303-9fd13543fe6e?w=800&q=80",
  "https://images.pexels.com/photos/8935909/pexels-photo-8935909.jpeg?w=800&q=80",
  "https://images.pexels.com/photos/8463037/pexels-photo-8463037.jpeg?w=800&q=80",
  "https://images.unsplash.com/photo-1495791185843-c73f2269f669?w=800&q=80",
  "https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?w=800&q=80",
];
